import type { StateCreator } from 'zustand';
import type { ModalProps } from '@/shared/ui';
import type { BoundStore } from './store.types';

type ModalConfig = Omit<ModalProps, 'isOpen' | 'onClose'>;

export type ModalSlice = {
	isModalOpen: boolean;
	modalConfig: ModalConfig;
	openModal: (config: ModalConfig) => void;
	closeModal: () => void;
};

const createModalSlice: StateCreator<BoundStore, [], [], ModalSlice> = (
	set,
) => ({
	isModalOpen: false,
	modalConfig: {},
	openModal: (config) => set({ isModalOpen: true, modalConfig: config }),
	closeModal: () => set({ isModalOpen: false }),
});

export default createModalSlice;
